import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { label: "Início", path: "/" },
    { label: "Produtos", path: "/produtos" },
    { label: "Contato", path: "/contato" },
  ];

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/60">
      <nav className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 shrink-0">
            <img
              src="https://storage.helloreaddy.io/project_files/6df48b80-c75c-4832-be6c-52c7656ae481/9ba7cdbd-4cc3-4b34-9d07-828f7801dc96_compressed_base_logo_transparent_background-1.webp"
              alt="REDENET"
              className="h-10 md:h-12 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap rounded-full ${
                  isActive(link.path)
                    ? "text-primary-700 bg-primary-50"
                    : "text-foreground-600 hover:text-primary-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <a
            href="https://wa.me/5583998460015"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-600 text-background-50 text-sm font-semibold hover:bg-primary-700 transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line" />
            Fale Conosco
          </a>

          <button
            type="button"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full text-foreground-800 hover:bg-background-100 transition-colors"
            aria-label="Menu"
          >
            <i className={`ri-${mobileOpen ? "close-line" : "menu-line"} text-xl`} />
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                  isActive(link.path)
                    ? "text-primary-700 bg-primary-50"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://wa.me/5583998460015"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-primary-600 text-background-50 text-sm font-semibold hover:bg-primary-700 transition-colors"
            >
              <i className="ri-whatsapp-line" />
              Fale Conosco
            </a>
          </div>
        </div>
      )}
    </header>
  );
}